import { useEffect } from 'react';
import { create } from 'zustand';

export type AppearancePreference = 'light' | 'dark' | 'auto';

export const APPEARANCE_PREFERENCE_STORAGE_KEY = 'mp.dev.platform.appearance';

export const loadAppearancePreference = (): AppearancePreference => {
  const stored = localStorage.getItem(APPEARANCE_PREFERENCE_STORAGE_KEY);
  return stored === 'light' || stored === 'dark' ? stored : 'auto';
};

interface AppearanceState {
  preference: AppearancePreference;
  savePreference: (preference: AppearancePreference) => void;
  loadPreference: () => void;
}

const useAppearanceStore = create<AppearanceState>((set) => ({
  preference: loadAppearancePreference(),
  savePreference: (preference) => {
    localStorage.setItem(APPEARANCE_PREFERENCE_STORAGE_KEY, preference);
    set({ preference });
  },
  loadPreference: () => set({ preference: loadAppearancePreference() }),
}));

export const saveAppearancePreference = (preference: AppearancePreference): void => useAppearanceStore.getState().savePreference(preference);

export const useAppearancePreference = () => {
  const preference = useAppearanceStore((state) => state.preference);
  const loadPreference = useAppearanceStore((state) => state.loadPreference);
  useEffect(loadPreference, [loadPreference]);
  return preference;
};
